export const required = value => (value ? undefined : 'Required')

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined

export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined

export const mediumPasswordRegex =
  new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')

export const mediumPassword = value =>
  value && !mediumPasswordRegex.test(value)
    ? 'At least one lowercase, one uppercase, and one number' : undefined

export const strongPasswordRegex =
  new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')

export const strongPassword = value =>
  value && !strongPasswordRegex.test(value) ? 'Medium strength' : undefined



// WEBPACK FOOTER //
// ./src/lib/validation.js